const PaperPlaneIcon = ({ color = "#363645", size = 16, className = "", ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
    >
        <path
            d="M2.39973 17.8131C1.03102 18.5033 -0.480849 17.1575 0.146869 15.8086L3.22411 10.1059L8.02496 9.07493L3.22411 7.89413L0.14687 2.19286C-0.482422 0.842535 1.03102 -0.503289 2.39974 0.186877L17.133 7.62716C17.3948 7.75938 17.6138 7.95712 17.7665 8.19913C17.9193 8.44114 18 8.71828 18 9.00075C18 9.28322 17.9193 9.56035 17.7665 9.80236C17.6138 10.0444 17.3948 10.2421 17.133 10.3743L2.39973 17.8131Z"
            fill={color}
        />
    </svg>
);

export default PaperPlaneIcon;